import type { PickerItemValidCheck } from "@9amhealth/shared";
import { getLocalTimeZone, now, ZonedDateTime } from "@internationalized/date";
import React, { FC, useRef } from "react";
import { TimePickerSheet } from "../TimePickerSheet/TimePickerSheet";
import reportErrorSentry from "src/lib/reportErrorSentry";
import ReactDOM from "react-dom";

const DateTimePicker: FC<{
  show: boolean;
  onFinish?: (dateTime: ZonedDateTime) => void;
  onChange?: (dateTime: ZonedDateTime) => void;
  initialDate?: ZonedDateTime;
  title: string;
  granularity: "day" | "minute";
  daysBack?: number;
  daysForward?: number;
  validateDate?: PickerItemValidCheck;
}> = (props) => {
  const {
    show,
    onFinish,
    onChange,
    initialDate = now(getLocalTimeZone()),
    title,
    granularity,
    daysBack,
    daysForward,
    validateDate
  } = props;
  const portalTarget = document.getElementById("date-time-picker-target");
  const selected = useRef<ZonedDateTime>(initialDate);

  const handleFinish = () => {
    onFinish?.(selected.current);
  };

  const handleSelectChange = (dateTime: ZonedDateTime) => {
    selected.current = dateTime;
    onChange?.(dateTime);
  };

  if (!show) {
    return null;
  }

  if (!portalTarget) {
    reportErrorSentry(new Error("DateTimePicker portal target not found"));
    return null;
  }

  return ReactDOM.createPortal(
    <TimePickerSheet
      onFinish={handleFinish}
      onChange={handleSelectChange}
      title={title}
      granularity={granularity}
      initialDate={initialDate}
      daysBack={daysBack}
      daysForward={daysForward}
      validateDate={validateDate}
    />,
    portalTarget
  );
};

export default DateTimePicker;
